import React from 'react'
import { TableCell } from '@mui/material';
import _ from 'lodash'
import { headerTyps } from '../../utils/forecastStaticData';
import { getNumberComma } from '../../utils/numberUtils';

const ForecastMonthStateCell = ({ headerRows, data }) => {
    if (!headerRows || !data) {
        return null;
    }

    return headerRows && headerRows.map((field, fIndex) => {
        return headerTyps.map((type, tIndex) => {
            let key = `${fIndex}_${tIndex}`;

            let value = _.has(data, `${field.val}.${type.id}`) ? data[field.val][type.id] : '-';
            let formatValue = (type.id !== 'profit') ? getNumberComma(value) : value;

            return (
                <TableCell sx={{ width: '80px', paddingLeft: '2px', paddingRight: '2px' }} align="right" key={key}>{formatValue}</TableCell>
            )
        })
    })
}

export default ForecastMonthStateCell